import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <p
    className={`text-xs uppercase tracking-[0.3em] ${
      dark ? "text-jawa-gold" : "text-jawa-terracotta"
    }`}
  >
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, dark = false, className = "" }) => (
  <div className={className}>
    <Overline dark={dark}>{overline}</Overline>
    <h2
      className={`mt-4 font-serif text-4xl font-medium tracking-tight sm:text-5xl ${
        dark ? "text-jawa-ivory" : "text-jawa-espresso"
      }`}
    >
      {title}
    </h2>
  </div>
);
